import { useCallback } from 'react'
import {
  getPatientRiskComplianceReport,
  type PatientRiskComplianceReportResult,
} from '@services/api/reports/patients.api'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type PatientRiskComplianceReportData = PatientRiskComplianceReportResult

export type UsePatientRiskComplianceReportResult = {
  loading: boolean
  error: string | null
  data: PatientRiskComplianceReportData | null
  bucketLabel: string
}

export function usePatientRiskComplianceReport(
  toolbarSelection: Record<string, string>,
): UsePatientRiskComplianceReportResult {
  const getBucketFromData = useCallback(
    (data: PatientRiskComplianceReportResult): ReportBucketType =>
      data.unscheduledByProductionBucket?.bucket ?? 'month',
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getPatientRiskComplianceReport,
    getBucketFromData,
    errorMessage: 'Failed to load patient risk and compliance data',
  })
}
